import { render, staticRenderFns } from "./tp-login.vue?vue&type=template&id=721ad598&scoped=true"
import script from "./tp-login.vue?vue&type=script&lang=ts"
export * from "./tp-login.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721ad598",
  null
  
)

export default component.exports